import { useEffect, useState } from "react";

/**
 * useReducedMotion, subscribes to `prefers-reduced-motion: reduce`.
 *
 * Components that run RAF-driven animation (count-ups, physics, waveform
 * scrubs) should wrap their motion paths with a check on this hook so
 * users who've asked for less motion don't get decorative animation.
 *
 * SSR-safe: returns `false` on first render when `window` is undefined.
 */
export function useReducedMotion(): boolean {
  const [reduced, setReduced] = useState<boolean>(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const onChange = (event: MediaQueryListEvent) => setReduced(event.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return reduced;
}
